import { Component, EventEmitter, OnInit, Inject } from '@angular/core';
import { ApiService } from 'src/app/pages/common/api.service';
import { debounceTime } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { forkJoin } from 'rxjs';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-search-modal',
  templateUrl: './search-modal.component.html',
  styleUrls: ['./search-modal.component.scss']
})
export class SearchComponent implements OnInit {
  private subject: Subject<string> = new Subject();

  // output vars
  searchItemEvent: EventEmitter<any> = new EventEmitter();
  hideEvent: EventEmitter<boolean> = new EventEmitter();
  selectedItemEvent: EventEmitter<any> = new EventEmitter();

  searching = false;
  itemList: Array<any>;

  searchInput = '';
  pathname: any;
  isSpecial: boolean;

  constructor(
    public _apiService: ApiService,
    @Inject(DOCUMENT) private document: any
  ) { }

  ngOnInit(): void {
    setTimeout(()=>{
      document.getElementById("search-input").focus();
    }, 500);
    this.subject.pipe(
      debounceTime(500)
    ).subscribe(inp => {
      this.searchItem(inp);
    });
    this.pathname = this.document.location.pathname.split('/',3);
    this.isSpecial = (this.pathname.length == 3 && this.pathname[2] == 'offers') ? true : false;
  }
  debouncedMerchantSearch(inp: any) {
    this.subject.next(inp);
  }
  hideModal() {
    this.hideEvent.emit(true);
  }


  searchItem(name) {
    if (this.searchInput.length > 2) {
      this.searching = true;
      this.itemList = [];
      const params = { name: this.searchInput };
      let apiArr = [this._apiService.searchMerchants(params)];
      if(this.isSpecial){
        apiArr.push(this._apiService.searchMerchants(params,true))
      }
      forkJoin(apiArr).subscribe((res: any) => {
      // this._apiService.searchMerchants(params).subscribe(
      //   (res: any) => {

         this.itemList = [];
          if (res[1] && res[1].data && res[1].data.length > 0) {
            res[1].data.forEach(obj =>{
              obj['res_type'] = {
                type: 'parent',
                path: this.pathname
              }
            })
            this.itemList = [ ...this.itemList, ...res[1].data.slice(0, 7)];

          }
          if (res[0] && res[0].data && res[0].data.length > 0) {
            res[0].data.forEach(obj =>{
              obj['res_type'] = {
                type: this.isSpecial ? 'special' : 'parent',
                path: this.pathname
              }
            })
            this.itemList = [ ...this.itemList, ...res[0].data.slice(0, 7)];

          }
          console.log(this.itemList);
          this.searching = false;
        },
        (err) => {
          this.searching = false;
        }
      );
    }
    else{
      this.searching = false;
      this.itemList = [];
    }
  }

  onItemClick(item) {
    this.selectedItemEvent.emit({
      item
    })
  }


}
